import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'cx_foundations-contactusbutton-click';

/**
 * Click Contact Us button in Help Center. The parameters indicates the source of the button, could be &quot;HOME_PAGE_HEADER&quot;, &quot;BRAND_GUIDES&quot;, &quot;RETAILER_GUIDES&quot; etc. There will also be parameters indicating the retailer token or brand token if the user is logged in.
 */
export function trackCxFoundationsContactusbuttonClick(
  Source_string: string,
  retailerToken: string,
  brandToken: string,
  strategy2: string = ''
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { Source_string, retailerToken, brandToken, strategy2 },
  });
}
